import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Ladder } from 'src/models/ladder.model';
import { Match } from 'src/models/match.model';
import { Pairing } from 'src/models/pairing.model';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { RecordService } from '../record/record.service';
import { DateTime } from 'luxon';
import { RecordMatchBaseComponent } from '../record/record.base.component';

@Component({
  selector: 'record-match-tournament',
  templateUrl: '../record/record.component.html',
  styleUrls: ['../record/record.component.scss'],
})
export class RecordMatchTournamentComponent extends RecordMatchBaseComponent implements OnInit {

  public zero_pairing_msg: string = "You have no matches to record for this tournament.";
  private returnTo: string = '/tournament';

  constructor(recordSvc: RecordService,
    userSvc: UserService, http: HttpClient, fb: FormBuilder, router: Router, private route: ActivatedRoute) {
    super(recordSvc, userSvc, http, fb, router);
  }

  public ngOnInit() {
    // Get the return route from query parameters
    this.route.queryParams.subscribe(params => {
      if (params['returnTo']) {
        this.returnTo = params['returnTo'];
      }
    });

    const p1 = this.userSvc.getUser();
    const p3 = this.http.get<Pairing[]>('/api/tournament/pairing');

    forkJoin([p1, p3]).subscribe(
      ([resp1, resp3]) => {
        this.player = new Player(resp1);

        this.pairings.length = 0;
        for (let p of resp3) {
          this.pairings.push(new Pairing(p));
        }
        // fix for iphone/ipad... need to assign first player for the select - null breaks things
        if (this.pairings.length > 0)
          this.matchForm.controls.opponentId.setValue(this.pairings[0].pairingPlayer.id);

        this.busy = false;
      },
      (err) => {

      }
    )
  };
  public saveMatch(evt: any) {
    if (this.busySave) return;
    this.busySave = true;
    let m = new Match(this.matchForm.value);
    this.recordSvc.recordMatchTournament(m).subscribe(
      (resp) => {
        // redirect back to the page we came from
        const returnRoute = this.returnTo === '/tournament16' ? '/tournament16' : '/tournament';
        this.router.navigate([returnRoute, this.player.ladderId], {queryParams: { retry: 0 }});
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }
  public saveRetiredWorker() {
    this.busySave = true;
    const m = new Match({ ...this.matchForm.value, Retired: true });
    this.recordSvc.recordMatchTournament(m).subscribe(
      (resp) => {
        // redirect back to the page we came from
        const returnRoute = this.returnTo === '/tournament16' ? '/tournament16' : '/tournament';
        this.router.navigate([returnRoute, this.player.ladderId]);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public saveForfeitWorker() {

    this.busySave = true;
    const m = new Match({ PairingId: this.matchForm.value.pairingId, Forfeit: true });
    this.recordSvc.recordMatchTournament(m).subscribe(
      (resp) => {
        // redirect back to the page we came from
        const returnRoute = this.returnTo === '/tournament16' ? '/tournament16' : '/tournament';
        this.router.navigate([returnRoute, this.player.ladderId]);
      },
      (err) => {
        this.busySave = false;
        alert(err.error);
      }
    )
  }

  public back(evt: any): void {
    evt.preventDefault();
    const returnRoute = this.returnTo === '/tournament16' ? '/tournament16' : '/tournament';
    this.router.navigate([returnRoute, this.player.ladderId]);
  }

  public saveForfeit(evt: any) {
    evt.preventDefault();
    if (this.busySave) return;
    if (this.matchForm.value.pairingId == undefined || this.matchForm.value.pairingId == null || this.matchForm.value.pairingId == 0) {
      alert('You must select an opponent.');
      return;
    }
    const opponentId = this.matchForm.value.opponentId;
    const p = this.pairings.find(p => p.pairingPlayer.id == opponentId);
    if (confirm(`Are you sure ${p.pairingPlayer.name} forfeited the match and you win?`)) {
      this.busySave = true;
      const m = new Match({ PairingId: this.matchForm.value.pairingId, Forfeit: true });
      this.recordSvc.recordMatchTournament(m).subscribe(
        (resp) => {
          // redirect back to the page we came from
          const returnRoute = this.returnTo === '/tournament16' ? '/tournament16' : '/tournament';
          this.router.navigate([returnRoute, this.player.ladderId]);
        },
        (err) => {
          this.busySave = false;
          alert(err.error);
        }
      )
    }
  }
}
